export default {
  bind(el) {
    const cursor = document.createElement('div');
    cursor.className = 'custom-cursor';
    el.classList.add('custom-cursor__parent');
    el.appendChild(cursor);

    const updateCursor = (e) => {
      requestAnimationFrame(() => {
        cursor.style.transform = `translate(${e.clientX - 71}px, ${e.clientY - 71}px)`;
      });
    };

    el.addEventListener('mousemove', updateCursor);
    el.addEventListener('mouseenter', () => { cursor.style.display = 'block'; });
    el.addEventListener('mouseleave', () => { cursor.style.display = 'none'; });

    el.__clean__ = () => {
      el.removeEventListener('mousemove', updateCursor);
      el.removeEventListener('mouseenter', () => { cursor.style.display = 'block'; });
      el.removeEventListener('mouseleave', () => { cursor.style.display = 'none'; });
    };
  },
  unbind(el) {
    if (el.__clean__) el.__clean__();
  }
};
